module.exports = __webpack_public_path__ + "img/boleto.a672d782.svg";